import React, { FC } from 'react';

import { TooltipProps } from './Tooltip.constants';
import { StyledToolTip } from './Tooltip.styles';

const ToolTip: FC<TooltipProps> = ({ width, toolTipInfo }) => {
  return <StyledToolTip width={width}>{toolTipInfo}</StyledToolTip>;
};

export default ToolTip;
